import { Navigate } from 'react-router-dom';
import { routes } from '@/lib/routes';

/** Self-registration is access-request based — keep /auth/register as a stable alias. */
const RegisterPage = () => <Navigate to={routes.requestAccess} replace />;

export default RegisterPage;
